import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-taupe text-warm-white/80">
      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="mb-4">
              <p className="font-serif text-2xl text-warm-white font-light tracking-wide">Cam Kirkwood</p>
              <p className="text-[9px] tracking-[0.3em] uppercase text-gold mt-1">Real Estate</p>
            </div>
            <p className="text-sm text-warm-white/60 leading-relaxed max-w-xs mb-6">
              Luxury real estate representation in the Lake Tahoe region. Precision, discretion, and results.
            </p>
            <img
              src="https://www.camkirkwood.com/images/logo-compass_w344.png"
              alt="Compass"
              className="h-6 opacity-50 object-contain"
            />
          </div>

          {/* Navigation */}
          <div>
            <p className="text-[10px] tracking-[0.25em] uppercase text-gold mb-5">Navigate</p>
            <ul className="space-y-3 text-sm">
              {['Home', 'Services', 'About', 'Locations'].map((item) => (
                <li key={item}>
                  <Link
                    to={item === 'Home' ? '/' : `/${item.toLowerCase()}`}
                    className="hover:text-warm-white transition-colors cursor-pointer"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <p className="text-[10px] tracking-[0.25em] uppercase text-gold mb-5">Contact</p>
            <ul className="space-y-3 text-sm">
              <li>
                <a href="tel:5617146589" className="flex items-center gap-2 hover:text-warm-white transition-colors cursor-pointer">
                  <i className="ri-phone-line text-gold text-xs" />
                  561-714-6589
                </a>
              </li>
              <li>
                <a href="tel:5616552359" className="flex items-center gap-2 text-warm-white/40 hover:text-warm-white/70 transition-colors cursor-pointer">
                  <i className="ri-printer-line text-gold/50 text-xs" />
                  Fax: 561-655-2359
                </a>
              </li>
              <li>
                <a href="mailto:cam@camkirkwood.com" className="flex items-center gap-2 hover:text-warm-white transition-colors cursor-pointer">
                  <i className="ri-mail-line text-gold text-xs" />
                  cam@camkirkwood.com
                </a>
              </li>
              <li className="text-warm-white/50 leading-relaxed pt-2 text-xs">
                Compass Florida, LLC<br />
                11000 Prosperity Farms Rd, Suite 103<br />
                Palm Beach Gardens, FL 33410
              </li>
            </ul>

            {/* Social */}
            <div className="flex flex-wrap gap-3 mt-6">
              {[
                { icon: 'ri-facebook-line', href: 'https://www.facebook.com/camkirkwood/', label: 'Facebook' },
                { icon: 'ri-twitter-x-line', href: 'https://twitter.com/CamKirkwood', label: 'Twitter' },
                { icon: 'ri-instagram-line', href: 'http://instagram.com/Cam_Kirkwood', label: 'Instagram' },
                { icon: 'ri-linkedin-line', href: 'https://www.linkedin.com/in/camkirkwood', label: 'LinkedIn' },
                { icon: 'ri-youtube-line', href: 'https://www.youtube.com/channel/UCgEZGJL5nO_dQswvptXAACA/featured', label: 'YouTube' },
              ].map(({ icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  aria-label={label}
                  className="w-8 h-8 flex items-center justify-center border border-warm-white/20 rounded-full hover:border-gold hover:text-gold transition-colors cursor-pointer"
                >
                  <i className={`${icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-warm-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-warm-white/40">
          <p>Copyright &copy; 2026 Cam Kirkwood. All Rights Reserved.</p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <a href="https://www.yelp.com/biz/cam-kirkwood-compass-jupiter" target="_blank" rel="noopener noreferrer nofollow" className="hover:text-warm-white/70 transition-colors cursor-pointer">Yelp</a>
            <a href="https://www.zillow.com/profile/CamKirkwood88/" target="_blank" rel="noopener noreferrer nofollow" className="hover:text-warm-white/70 transition-colors cursor-pointer">Zillow</a>
            <a href="https://www.realtor.com/realestateagents/cam-kirkwood_palm-beach-gardens_fl_3714488" target="_blank" rel="noopener noreferrer nofollow" className="hover:text-warm-white/70 transition-colors cursor-pointer">Realtor.com</a>
            <a href="https://www.trulia.com/profile/camkirkwood-agent-palm-beach-fl-zgt0h44k/overview" target="_blank" rel="noopener noreferrer nofollow" className="hover:text-warm-white/70 transition-colors cursor-pointer">Trulia</a>
          </div>
          <p>South Lake Tahoe &bull; Alpine County &bull; El Dorado County &bull; Sierra Nevada</p>
        </div>
      </div>
    </footer>
  );
}
